import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setUser } from '../utils/auth';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // The JWT is stored in an httpOnly cookie set by the backend.
    // Verify authentication by calling /api/auth/me and store non-sensitive user info.
    fetch('/api/auth/me', { credentials: 'include' })
      .then((res) => {
        if (!res.ok) throw new Error('Not authenticated');
        return res.json();
      })
      .then((user) => {
        setUser(user);
        navigate('/dashboard');
      })
      .catch(() => {
        navigate('/login');
      });
  }, [navigate]);

  return <p>Logging you in...</p>;
};

export default AuthCallback;
